export enum EnumCompletionCode {
  'None' = 1,
  'Completed',
  'Investigate',
  'Partial Dispense',
  'Terminal Fault',
  'Time Out',
  'Unable to Capture Card',
  'Cancelled',
  'Invalid Data'
}

export namespace EnumCompletionCode {
  export function values() {
    return Object.keys(EnumCompletionCode).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
